import { PublishersAutoSuggest } from 'app/employer/components/autoSuggest';
import withAutoSuggestFormik from './withAutoSuggestFormik';

export default withAutoSuggestFormik(PublishersAutoSuggest);
